'use strict';

// external imports
import React, {
    useMemo
} from 'react';
import {useSelector} from 'react-redux';
import {keys} from 'ts-transformer-keys';

// prime react imports
import {Toolbar as PrimeToolbar} from 'primereact/toolbar';

// shared imports
import {__} from '~/shared/src/utilities/messageCatalog';

// frontend imports
import {StoreState} from '~/frontend/src/store';
import {
    getToolbarComponents,
    ToolbarComponents,
    ToolbarLayoutComponents
} from '~/frontend/src/utilities/toolbars';

// action imports


export type DefaultProps = {
    toggleSelectionButtonDisabled? : boolean;
    deleteButtonDisabled? : boolean;
};
export const defaultProps : Required<DefaultProps> = {
    toggleSelectionButtonDisabled: true,
    deleteButtonDisabled         : true
};

export type Props = {

    /**
     * The uniqueId of the panel the component is used in.
     *
     * Mostly used to extract the components state from the global one
     * and to generate unique dom element ids.
     */
    uid : string;

    onSelectFile : () => void;
    onToggleSelection : () => void;
    onDelete : () => void;
};
export type ComponentProps = DefaultProps & Props;
export const componentProps = keys<ComponentProps>();

type AllProps = Required<DefaultProps> & Props;


/**
 * Toolbar
 */
const Toolbar = ( props : AllProps ) => {
    const {
              uid,
              onSelectFile,
              toggleSelectionButtonDisabled,
              onToggleSelection,
              deleteButtonDisabled,
              onDelete
          }                       = props,
          user                    = useSelector( ( state : StoreState ) => state.session?.user ),
          language                = user ? user.language : undefined;

    return useMemo(
        () => {
            const layoutComponents : ToolbarLayoutComponents = {
                left : [],
                right: []
            };

            // left
            layoutComponents.left.push( {
                type  : 'button',
                params: {
                    key: `${uid}_selectFileButton`,

                    label    : __( 'YN.base.xmlImport.fileUpload.selectFile.label' ),
                    onClick  : onSelectFile,
                    className: 'p-button-text'
                }
            } );
            layoutComponents.left.push( {
                type  : 'button',
                params: {
                    key: `${uid}_toggleSelectionButton`,

                    label    : __( 'YN.base.xmlImport.fileUpload.toggleSelection.label' ),
                    disabled : toggleSelectionButtonDisabled,
                    onClick  : onToggleSelection,
                    className: 'p-button-text'
                }
            } );
            layoutComponents.left.push( {
                type  : 'button',
                params: {
                    key: `${uid}_deleteButton`,

                    label    : __( 'YN.base.xmlImport.fileUpload.delete.label' ),
                    disabled : deleteButtonDisabled,
                    onClick  : onDelete,
                    className: 'p-button-text'
                }
            } );

            // right

            const toolbarComponents : ToolbarComponents = getToolbarComponents( layoutComponents );

            return <PrimeToolbar
                left={toolbarComponents.left}
                right={toolbarComponents.right}
                className="yn-panel-toolbar shadow-4"
                style={{ zIndex: 5 }}
            />;
        },
        [
            uid,
            onSelectFile,
            toggleSelectionButtonDisabled,
            onToggleSelection,
            deleteButtonDisabled,
            onDelete,
            language
        ] );
};
Toolbar.defaultProps = defaultProps;
Toolbar.displayName = 'XmlImport-Input-Toolbar';

export default Toolbar;
